export default __webpack_public_path__ + "static/media/branding-logo.42de032a.svg";